export const styles = {
  container:
    "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 relative before:absolute before:left-0 before:right-0 before:top-[60px] before:h-[1px] before:bg-gray-200 dark:before:bg-gray-700",
  header: "px-0 py-1",
  title: "text-theme-xl font-semibold text-gray-800 dark:text-white/90",
  tableCard:
    "bg-white dark:bg-gray-800 rounded-lg mt-9 border border-gray-200 dark:border-gray-700 overflow-hidden",
  headerControls:
    "flex flex-col sm:flex-row justify-between items-center p-4 border-b border-white dark:border-gray-700 bg-white dark:bg-gray-800 gap-4 sm:gap-6",
  controlsInner:
    "flex flex-wrap sm:flex-nowrap items-center w-full sm:w-auto gap-2 sm:gap-2",
  searchContainer: "relative flex items-center flex-1 w-full sm:w-auto h-10",
  searchInput:
    "h-11 w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-11 pr-4 text-sm text-gray-800 shadow-sm placeholder:text-gray-400 focus:border-brand-300 focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 xl:w-[200px]",
  searchIcon: "absolute left-3 text-gray-400 dark:text-gray-300 w-4 h-4",
  downloadButton:
    "inline-flex items-center justify-center rounded-lg px-4 py-3 text-sm bg-white text-gray-700 ring-1 ring-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/[0.03] dark:hover:text-gray-300",
  downloadIcon: "w-5 h-5 ml-2",
  addButtonContainer: "w-full sm:w-auto",
  addButton:
    "inline-flex items-center justify-center gap-2 rounded-lg px-4 py-3 text-sm bg-[#2f6aa7] dark:bg-[#3d6794] text-white shadow-sm hover:bg-[#2779bd] dark:hover:bg-[#335877] disabled:bg-brand-300 w-full sm:w-auto",
  errorText: "text-red-500 text-sm",
  tableContainer: "overflow-x-auto max-h-[500px] block", 
  table: "w-full border-collapse table-auto min-w-[600px] border-separate border-spacing-0",
 theadRow: "sticky top-0 z-10 bg-white dark:bg-gray-900 text-left font-medium text-gray-700 theme-xs dark:text-gray-400 border-b border-gray-300 dark:border-gray-700",
  th: "px-4 py-3 border border-gray-100 dark:border-white/[0.05] text-sm",
  thSortable: "flex items-center justify-between cursor-pointer",
  thText: "font-bold text-gray-800 theme-xs dark:text-gray-400",
  sortButton: "flex flex-col gap-0.5",
  tbodyRow: "border border-gray-100 dark:border-white/[0.05]",
  td: "px-4 py-4 font-normal text-gray-800 dark:text-gray-400 text-theme-sm border border-gray-100 dark:border-white/[0.05] break-words",
  statusContainer: "flex items-center gap-1.5",
  statusToggle:
    "w-8 h-4.5 rounded-full flex items-center px-0.5 transition-all",
  statusToggleActive: "bg-green-500 dark:bg-green-400",
  statusToggleInactive: "bg-red-500 dark:bg-red-400",
  statusToggleCircle:
    "w-3 h-3 bg-white rounded-full transition-transform",
  statusToggleCircleActive: "translate-x-4",
  statusToggleCircleInactive: "translate-x-0",
  statusBadge: "text-xs inline-flex items-center justify-center px-2.5 py-0.5 rounded-full",
  statusActive: "text-green-700 dark:text-green-300",
  statusInactive: " text-red-700 dark:text-red-300",
  actionContainer: "flex items-center space-x-1.5",
  editButton:
  "w-6 h-6 bg-[#2f6aa7] dark:bg-[#3d6794]  flex items-center justify-center rounded-md shadow hover:bg-[#2779bd] dark:hover:bg-[#335877] transition",
  deleteButton:
  "w-6 h-6 bg-red-600  dark:bg-red-400 flex items-center justify-center rounded-md shadow hover:bg-red-500 dark:hover:bg-red-600 transition",
  actionIcon: "w-3 h-3 md:w-4 md:h-4",
  loadingText: "text-center text-gray-500 dark:text-gray-400 py-4",
  noDataText: "text-center text-gray-500 dark:text-gray-400 py-4",
  modal:
    "w-[80%] max-w-[400px] bg-white dark:bg-gray-900 px-6 py-6 rounded-lg shadow-xl mx-auto text-center relative",
  modalIconContainer:
    "w-14 h-14 flex items-center justify-center bg-red-100 text-red-600 rounded-full mx-auto",
  modalIcon: "w-6 h-6",
  modalTitle: "text-lg font-bold text-gray-800 dark:text-white mt-4",
  modalText: "text-sm text-gray-500 dark:text-gray-400 mt-2",
  modalButtonContainer: "mt-6 flex justify-center gap-4",
  modalCancelButton:
    "px-4 py-2 border border-gray-300 text-gray-700 dark:text-white rounded-md hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-700",
  modalDeleteButton: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700",
};